import React from "react";
import dynamic from "next/dynamic";

import { RouteLoaderApp } from "../../../constants/route-loader";
import useRouteTransitionLoader from "../../../hooks/useRouteTransitionLoader";

const TruckLoader = dynamic(() => import("../truck-loader/TruckLoader"), { ssr: false });

type RouteTransitionLoaderProps = {
    app: RouteLoaderApp;
};

const RouteTransitionLoader = ({ app }: RouteTransitionLoaderProps) => {
    const isLoading = useRouteTransitionLoader(app);

    if (!isLoading) {
        return null;
    }

    return <TruckLoader />;
};

export default RouteTransitionLoader;
